import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Modal, Form, Breadcrumb, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import { InforAlert, getRoles } from '../../utils/swtAlert';
import { GrokLoading } from '../page-layout/loading/Loading';
import { Decrypt } from '../../utils/Helper';
import { TimerAlert, ConfirmAlert } from '../../utils/swtAlert';
import { GetClosedChallenegs, GetParticpatedColleges, GetChallenegeWinnerStudent, challengeWinner, GetChallengeWinner, GetApproval } from '../../utils/axios/ChallengeWinnerAPI';
import { Margin, usePDF } from "react-to-pdf";
import "./Certificate.css";
import { GetOrganization } from '../../utils/axios/CompanyAPI';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { ORGANIZATION_TYPE } from "../constants/constants";

const WinnerAnnouncement = () => {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [clearRows, setClearRows] = useState(false);
    const [role, setRole] = useState('');
    const [validated, setValidated] = useState(false);
    const [challengesList, setChallengesList] = useState([]);
    const [collegesList, setCollegesList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [organizationList, setOrgnanizationList] = useState([]);
    const [approve, setApprove] = useState(false);

    const [challengename, setChallengename] = useState("");
    const [collegeId, setCollegeId] = useState("");
    const [studentId, setStudentId] = useState("");
    const [organizationId, setOrganizationId] = useState("");
    const [notes, setNotes] = useState("");
    const [addWinner, setAddWinner] = useState(Array(1));
    const [certificateData, setCertificateData] = useState([]);
    const [error, setError] = useState(false);
    const [proposed, setProposed] = useState(false);
    const [displaytoggle, setDisplayToggle] = useState(true);
    const [isPreview, setIsPreview] = useState(false);
    const [approvedStudents, setApprovedStudents] = useState({});

    const challengeRef = useRef([]);
    const collegeRef = useRef([]);
    const studentRef = useRef([]);
    const notesRef = useRef([]);
    const orgRef = useRef([]);
    const companyRef = useRef();
    const columns = [
        {
            name: "Use Case Name",
            selector: row => row.ChallengeName,
            sortable: true,
            cell: row => row.ChallengeName,
        },
        {
            name: "Winners Details",
            width: "150px",
            cell: (row) => (<>
                <button className="btn btn-link" title="Participant Details" onClick={() => handleShowParticipants(row.Organizations, row.ChallengeName)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><circle cx="152" cy="184" r="72"></circle><path d="M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"></path><path d="M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"></path><circle cx="340" cy="168" r="88"></circle></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            omit: (role == "Student") ? true : false
        },
    ]
    const [data, setData] = useState();
    const tableData = {
        columns,
        data,
        print: false,
        export: false
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            winnercreate();
            setValidated(false);
        }
    }

    const HandleApproved = (event) => {
        ConfirmAlert("Announce as Winner!", 'Are you sure? Do you want to announce this participant as a Winner?', 'question', 'Yes')
            .then(async (result) => {
                if (result.value) {
                    await getapproval(event.Id);
                    TimerAlert('success', 'Winner announced Successfully', 'success');
                    setApprovedStudents((prev) => ({ ...prev, [event.Id]: true }));
                    setLoading(false);
                }
            });
    }

    const getapproval = async (id) => {
        setLoading(true);
        let approvalpayload = {
            StudentChallengeId: id,
            IsWinner: true
        }
        var ApprovalResponse = await GetApproval(approvalpayload);
        if (ApprovalResponse.IsGenerateCertificate) {
            getWinnerList(organizationId, proposed);
            InforAlert("success", 'Approved', 'success', 'OK')
                .then((result) => {
                    if (result.isConfirmed) {
                        getOrganization();
                        handleCloseParticipants();
                    }
                });
        }
        else if (ApprovalResponse.message == "Request failed with status code 400") {
            InforAlert("warning", 'Certificate already generated for this challenge.', 'warning', 'OK')
        }
        setLoading(false);
    }

    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', { state: { companyid: null } });
    }

    const filterRef = useRef();
    const { toPDF, targetRef } = usePDF({
        // filename: (`${name}-${challengeName}`),
        filename: "Industry use case winner",
        page: { margin: Margin.MEDIUM }
    });

    const [registerShow, setRegisterShow] = useState(false);
    const handleRegisterClose = () => {
        setRegisterShow(false);
    };
    const handleRegisterShow = () => {
        if (role === 'Company') {
            getClosedChallenges(userInfo.OrganizationId);
        }
        setRegisterShow(true);
    };

    const studentNameRef = useRef();
    const studentGenderRef = useRef();
    const studentCollegeRef = useRef();
    const companyNameRef = useRef();
    const companyName2Ref = useRef();
    const challengeNameRef = useRef();
    const companyLogoRef = useRef();
    const certificateIdRef = useRef();

    //winner certificate modal
    const [certificateShow, setCertificateShow] = useState(false);
    const handleCertificateClose = () => { setCertificateShow(false); }
    const handleCertificateShow = (studentname, college, company, gender, certificateID, logo) => {
        setCertificateShow(true);
        setCertificateData(data);
        setTimeout(() => {
            studentNameRef.current.innerText = studentname;
            studentGenderRef.current.innerText = gender === 'Male' ? 'Mr.' : 'Ms.';
            studentCollegeRef.current.innerText = college.Name;
            companyNameRef.current.innerText = company;
            challengeNameRef.current.innerText = challengename;
            certificateIdRef.current.innerText = certificateID;
            console.log(certificateID)
            if (logo !== "") {
                companyLogoRef.current.src = logo;
            }
            if (certificateID === "Preview") {
                setIsPreview(true);
            }
            else {
                setIsPreview(false);
            }
        }, 10)

    };

    // get list of challegewinner
    const getWinnerList = async (orgId, proposed) => {
        setLoading(true);
        console.log(proposed);
        let winnerPayload = {
            OrganizationId: orgId,
            CertificateProposed: true,
            DeclaredWinner: !proposed ? true : false
        }
        var winnerGetResponse = await GetChallengeWinner(winnerPayload);
        if (winnerGetResponse.data) {
            setData(winnerGetResponse.data);
        }
        else {
            setError(true);
            InforAlert("warning", "Oops Please reload the page!", "warning", 'ok');
        }
        setLoading(false);
    }

    const getClosedChallenges = async (e) => {
        setLoading(true);
        let closedChallenges = {
            OrganizationId: e
        }

        var closedChallengesResponse = await GetClosedChallenegs(closedChallenges);
        setChallengesList(closedChallengesResponse.data);
        setLoading(false);
    }

    const getStudent = async (index, challengeId, college) => {
        setLoading(true);
        let winnerStudents = {
            OrganizationId: college,
            ChallengeId: challengeId
        }

        var winnerStudentsResponse = await GetChallenegeWinnerStudent(winnerStudents);
        //To get/bind the students list at the particular index 
        const updatedStudentsList = [...studentList];
        updatedStudentsList[index] = [winnerStudentsResponse.data];
        setStudentList(updatedStudentsList);
        setLoading(false);
    }

    //show winner list 
    const [showParticipants, setShowParticipants] = useState(false);
    const [orgdetails, setOrgdetails] = useState([]);
    const handleCloseParticipants = () => setShowParticipants(false);

    // challenge participants modal, view solution and generate certificate
    const handleShowParticipants = async (orgName, challengeName) => {
        setChallengename(challengeName);
        setShowParticipants(true);
        console.log(orgName);
        setOrgdetails(orgName)
    };

    const handleChallengeChange = async (index, name, value) => {
        const updatedWinners = [...winners];
        updatedWinners[index][name] = value;
        // To clear the org id and student id from the object
        updatedWinners[index]['OrganizationId'] = '';
        updatedWinners[index]['StudentId'] = '';

        // To clear the field
        orgRef.current[index].value = '';
        studentRef.current[index].value = '';
        setAddWinner(updatedWinners);

        if (value !== '') {
            let participatedColleges = {
                ChallengeId: value
            }
            var participatedCollegesResponse = await GetParticpatedColleges(participatedColleges);

            if (participatedCollegesResponse.success) {
                //To get/bind the colleges list at the particular index 
                const updatedCollegesList = [...collegesList];
                updatedCollegesList[index] = [participatedCollegesResponse.data];
                setCollegesList(updatedCollegesList);
                //To make the student list empty when changing the org.
                const updatedStudentList = [...studentList];
                updatedStudentList[index] = [];
                setStudentList(updatedStudentList);
            }
        }
        else {
            const updatedCollegesList = [...collegesList];
            updatedCollegesList.splice(index, 1, []);
            const updatedStudentsList = [...studentList];
            updatedStudentsList.splice(index, 1, []);
            setCollegesList(updatedCollegesList);
            setStudentList(updatedStudentsList);
        }
    }

    const handleCollegeChange = async (index, name, value) => {
        const updatedWinners = [...winners];
        updatedWinners[index][name] = value;
        updatedWinners[index]['StudentId'] = '';
        studentRef.current[index].value = ''
        setAddWinner(updatedWinners);

        if (value !== '') {
            getStudent(index, updatedWinners[index]['ChallengeId'], value);
        }
        else {
            const updatedStudentsList = [...studentList];
            updatedStudentsList.splice(index, 1, []);
            setStudentList(updatedStudentsList);
        }
    }

    const winnercreate = async () => {
        setLoading(true);
        let winnerPayload = {
            records: winners
        }

        var winnerResponse = await challengeWinner(winnerPayload);
        setLoading(false);
        if (winnerResponse.data) {
            TimerAlert("success", "Industry use case Winner Created Successfully", "success");
            handleRegisterClose();
            getWinnerList(userInfo.OrganizationId);
            setWinners([{ ChallengeId: '', OrganizationId: '', StudentId: '', Notes: '' }]);
        }
    }

    // Winner toggle button
    const HandleSwitch = () => {
        setProposed(!proposed);
    }

    useEffect(() => {
        // Winner proposal 
        if (organizationId !== "") {
            getWinnerList(organizationId, proposed);
        }
        else {
            // return
        }
    }, [organizationId, proposed])

    //Expanded Tabl
    const getOrganization = async () => {
        let organizationPayload = {
            OrganizationType: ORGANIZATION_TYPE.COMPANY
        }
        var organizationResponse = await GetOrganization(organizationPayload);
        setLoading(false);
        if (organizationResponse.success) {
            setOrgnanizationList(organizationResponse.data);
        }
        else {
            setError(true);
            InforAlert("warning", "Oops Please reload the page!", "warning", 'ok');
        }
        setClearRows(false);
    }

    const handleOrganizationChange = (e) => {
        setOrganizationId(e.target.value);

        if (e.target.value != '') {
            // getWinnerList(e.target.value);
        }
    }

    const handleWinnerOrganizationChange = (e) => {
        setOrganizationId(e.target.value);

        if (e.target.value !== '') {
            getClosedChallenges(e.target.value);
        }
    }

    const handleClear = () => {
        //To clear all the values from all the fields
        if (role === 'Grok Admin') {
            companyRef.current.value = '';
        }
        notesRef.current.map(item => item !== null ? item.value = '' : '');
        if (role === 'Grok Admin') {
            setChallengesList([]);
        }
        setCollegesList([]);
        setStudentList([]);
        //To make all the items in the winner array empty
        for (let i = 0; i <= winners.length - 1; i++) {
            const updatedWinners = [...winners]
            updatedWinners[i].ChallengeId = '';
            updatedWinners[i].OrganizationId = '';
            updatedWinners[i].StudentId = '';
            updatedWinners[i].Notes = '';
            setWinners(updatedWinners);
        }
    }

    const clear = () => {
        ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
            .then((result) => {
                if (result.isConfirmed) {
                    handleClear();
                }
            });
    };

    const [winners, setWinners] = useState([{ ChallengeId: '', OrganizationId: '', StudentId: '', Notes: '' }]);

    const handleAddUser = () => {
        if (winners.length >= 1 && winners[0].ChallengeId !== '') {
            setWinners([...winners, { ChallengeId: winners[0].ChallengeId, OrganizationId: '', StudentId: '', Notes: '' }]);
        }
        setWinners([...winners, { ChallengeId: '', OrganizationId: '', StudentId: '', Notes: '' }]);
    };

    const handleRemoveUser = (index) => {
        // orgRef.current[index].value = "";
        // studentRef.current[index].value = "";
        const updatedWinners = [...winners];
        updatedWinners.splice((index), 1);
        setWinners(updatedWinners);
        const updatedStudentsList = [...studentList];
        updatedStudentsList.splice(index, 1);
        setStudentList(updatedStudentsList);
    };

    const handleInputChange = (index, field, value) => {
        const updatedWinners = [...winners];
        updatedWinners[index][field] = value;
        setWinners(updatedWinners);
    };

    useEffect(() => {
        const role = getRoles(userInfo);
        setRole(role);
        if (role == 'Company') {
            getWinnerList(userInfo.OrganizationId);
        }
        else if (role === 'Grok Admin') {
            getOrganization();
        }
    }, [])


    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Industry Use Case Winner</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Industry use case'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.07rem" width="1.07rem" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,15 C8.686,15 6,12.314 6,9 L6,1 L18,1 L18,9 C18,12.314 15.314,15 12,15 Z M6,3 L1,3 L1,7 C1,9.509 2.791,11 5,11 L6,11 L6,3 Z M18,11 L19,11 C21.209,11 23,9.509 23,7 L23,3 L18,3 L18,11 Z M5,23 L19,23 L19,19 L5,19 L5,23 Z M16,19 C16,16.790861 14.209139,15 12,15 C9.790861,15 8,16.790861 8,19"></path></svg>
                                    </span>
                                </Button>
                                <h2 className="page-title">Industry Use Case Winner</h2>
                            </Col>

                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    {(role === 'Grok Admin') && <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="card-title fw-bold mb-0 switchButton">
                                                <BootstrapSwitchButton
                                                    checked={proposed}
                                                    onlabel='Proposed Winners'
                                                    onstyle='primary'
                                                    offlabel='Declared Winners'
                                                    offstyle='secondary'
                                                    style='w-100 mx-5'
                                                    onChange={HandleSwitch}
                                                />
                                            </div>
                                        </div>
                                    </Col>}
                                    {(role === 'Grok Admin') && <Col lg={3} className='col-12 col-md-auto ms-auto d-print-none mb-3 mb-lg-0'>
                                        <Form.Group>
                                            <div className="col">
                                                <Form.Select as="select" required value={organizationId} onChange={(e) => handleOrganizationChange(e)}>
                                                    <option value="">Industry Partner</option>
                                                    {organizationList.map(item =>
                                                        <option key={item._id} value={item._id}>{item.Name}</option>)
                                                    }
                                                </Form.Select>
                                            </div>
                                        </Form.Group>
                                    </Col>}
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        <button className="ms-2 backBtn_style" onClick={() => handleRegisterShow()}>
                                            Suggest Winner
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                            <div className='taablist'>
                                <DataTableExtensions {...tableData}>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        fixedHeader
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        pagination
                                        paginationPerPage={20}
                                        paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                        clearSelectedRows={clearRows}
                                    />
                                </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Modal show={showParticipants} onHide={handleCloseParticipants} size="xl" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            {loading ? <GrokLoading className="loading_src_style" /> : ""}
                            <Modal.Header closeButton>
                                <Modal.Title><b>Participants Details</b> </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className='challenge_detail_style mb-3 d-flex bold'>
                                    <h5 id='ChallengeTitle' className='mx-2 mt-1'>{challengename}</h5>{role !== "Company" && `-`}
                                    {role !== "Company" && <h5 id='ChallengeOrgName' className='mx-2 mt-1'></h5>}
                                </div>
                                <div className='mt-2'>

                                    <Table striped bordered hover className='p-3'>
                                        <thead className='title'>
                                            <tr>
                                                <th>Associate College</th>
                                                <th>Participant</th>
                                                <th>Remarks</th>
                                                {!proposed && <th>Certificate</th>}
                                                {(role === 'Grok Admin' && proposed) && <th>Winner Status</th>}
                                            </tr>
                                        </thead>
                                        <tbody className='title'>
                                            {orgdetails?.map((org, i) => (
                                                org.Students.map((student, j) => (
                                                    <tr key={org.CompanyId}>
                                                        {j === 0 && (
                                                            <td rowSpan={org.Students.length} key={`${org.CompanyId}-${org.organizationId}`} className='text-nowrap'>
                                                                {org.organizationId.Name}
                                                            </td>
                                                        )}
                                                        <td className='text-nowrap'>{student.StudentName}</td>
                                                        <td className='text-nowrap'>{student.Notes}</td>
                                                        {!proposed &&
                                                            <td>
                                                                <button
                                                                    className="btn btn-link ms-1"
                                                                    title="Certificate"
                                                                    onClick={() => handleCertificateShow(student.StudentName, org.organizationId, org.CompanyName, student.Gender, student.CertificateId, org.CompanyLogo)}
                                                                >
                                                                    <span>
                                                                        <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path strokeWidth="2" d="M15 19H2V1h16v4m0 0a5 5 0 110 10 5 5 0 010-10zm-3 9v8l3-2 3 2v-8M5 8h6m-6 3h5m-5 3h2M5 5h2" ></path> </svg>
                                                                    </span>
                                                                </button>
                                                            </td>}
                                                        {(role === 'Grok Admin' && proposed) && <td>
                                                            {
                                                                approvedStudents[student.Id] ?
                                                                    <button className="btn centering btn-link ms-2 approved_btn">Approved</button>
                                                                    : <button className="btn centering btn-link ms-2 announce_btn" title="Click here to announce the winner" onClick={() => HandleApproved(student)}>Pending</button>
                                                            }
                                                        </td>}
                                                    </tr>
                                                ))
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                    <div>
                        <Modal show={registerShow} onHide={handleRegisterClose} size="xl" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            <Modal.Header closeButton>
                                <Modal.Title><b>Use Case Winner Announcement</b> </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    {loading ? <GrokLoading /> : ""}
                                    <Form autoComplete="off" noValidate validated={validated} onSubmit={handleSubmit}>
                                        <Row className="">
                                            {role === 'Grok Admin' && <Col lg={4} md={6} className='mb-3'>
                                                <Form.Label>Industry Partner<em className="Required">*</em></Form.Label>
                                                <div className="col">
                                                    <Form.Select as="select" ref={companyRef} required onChange={(e) => handleWinnerOrganizationChange(e)}>
                                                        <option value={""}>Industry Partner</option>
                                                        {organizationList.map((item) =>
                                                            <option key={item._id} value={item._id}>{item.Name}</option>
                                                        )};
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid"> Industry Partner is required</Form.Control.Feedback>
                                                </div>
                                            </Col>}
                                            <Col className='d-flex align-items-center justify-content-end'>
                                                <Button variant="success" size="sm" type="button" onClick={handleAddUser} disabled={winners.length <= 2 ? false : true}>
                                                    <span>
                                                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1.2" baseProfile="tiny" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M18 10h-4v-4c0-1.104-.896-2-2-2s-2 .896-2 2l.071 4h-4.071c-1.104 0-2 .896-2 2s.896 2 2 2l4.071-.071-.071 4.071c0 1.104.896 2 2 2s2-.896 2-2v-4.071l4 .071c1.104 0 2-.896 2-2s-.896-2-2-2z"></path></svg>
                                                    </span>
                                                </Button>
                                            </Col>
                                        </Row>
                                        {winners.map((winner, index) =>
                                            <div>
                                                <Row className="align-items-center">
                                                    <Col lg={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Use Case Name<em className="Required">*</em></Form.Label>
                                                            <div className="col">
                                                                <Form.Select as="select" ref={(el) => { challengeRef.current[index] = el }} value={winner.ChallengeId} required onChange={(e) => handleChallengeChange(index, 'ChallengeId', e.target.value)}>
                                                                    <option value={""}>Select</option>
                                                                    {challengesList.map((item) =>
                                                                        <option key={item.challengeid} value={item.challengeid}>{item.challengetitle}</option>
                                                                    )};
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid"> Use Case is required</Form.Control.Feedback>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Participant College Name<em className="Required">*</em></Form.Label>
                                                            <div className="col">
                                                                <Form.Select as="select" ref={(el) => { orgRef.current[index] = el }} value={winner.OrganizationId} required onChange={(e) => handleCollegeChange(index, 'OrganizationId', e.target.value)}>
                                                                    <option value={""}>Select</option>
                                                                    {collegesList[index]?.map((item, index) => (
                                                                        item.map(i =>
                                                                            <option key={i.id} value={i.id}> {i.Name}</option>
                                                                        )
                                                                    )
                                                                    )};
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid">Associate CollegeName is required</Form.Control.Feedback>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Participant Name<em className="Required">*</em></Form.Label>
                                                            <div className="col">
                                                                <Form.Select as="select" ref={(el) => { studentRef.current[index] = el }} value={winner.StudentId} required onChange={(e) => { handleInputChange(index, 'StudentId', e.target.value) }}>
                                                                    <option value={""}>Select</option>
                                                                    {studentList[index]?.map((item) => (
                                                                        item.map(i =>
                                                                            <option key={i?.StudentId} value={i?.StudentId}>{i?.studentName}</option>
                                                                        )
                                                                    )
                                                                    )};
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid"> Participant is required</Form.Control.Feedback>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col lg={11}>
                                                        <Form.Group className="mb-4">
                                                            <Form.Label>Remarks <em className="Required">*</em></Form.Label>
                                                            <div className='col'>
                                                                <Form.Control as="textarea" ref={(el) => { notesRef.current[index] = el }} type="text" id="EvaluateBrief" value={winner.Notes} style={{ height: '80px' }} minLength={3} placeholder="Enter remarks here..." required onChange={e => handleInputChange(index, 'Notes', e.target.value)} />
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                    {winners.length > 1 && <Col lg={1}>
                                                        <Button variant="secondary" size="sm" type="button" onClick={() => handleRemoveUser(index)}>
                                                            <span>
                                                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                                            </span>
                                                        </Button>
                                                    </Col>}
                                                </Row><hr />
                                            </div>
                                        )}
                                        <Row className=''>
                                            <Col md={4}>
                                                <Button variant="danger" size="sm" type="button" onClick={clear}> Clear </Button>
                                            </Col>
                                            <Col>
                                                <div className="d-flex gap justify-content-end">
                                                    <Button variant="success" type="submit" size="sm"> Save </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>

                    <div>
                        <Modal show={certificateShow} onHide={handleCertificateClose} size="lg" backdrop="static" keyboard={false} className="model-popup" aria-labelledby="contained-modal-title-vcenter" centered>
                            {loading ? <GrokLoading /> : ""}
                            <Modal.Header closeButton>
                                <Modal.Title><b>Industry Use Case Winner Certificate</b> </Modal.Title>
                                <div className='mx-5'>
                                    {!isPreview && <button className="downloadBtn" x={30} onClick={toPDF}>
                                        <span><svg className='mb-1' stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z" fill="currentColor"></path><path d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z" fill="currentColor"></path></svg>&nbsp;
                                            Download
                                        </span>
                                    </button>}
                                </div>
                            </Modal.Header>
                            <div ref={targetRef}>
                                <Modal.Body className="mx-2 my-3">
                                    <div className='my-3'>
                                        <div className="container gcc-win-certificate-container">
                                            <div className='border-line1'>
                                                <div className='border-line2'>
                                                    <div className="gcc-win-certificate-border col-md-12">
                                                        <div className="pm-certificate-body win_certificate_head">
                                                            <img src={require("../../images/certificate_img/header_logo.png")} className="bgs-logo" alt="logo" title="Profile" />
                                                            <div className="row pm-certificate-header">
                                                                <div className="col-md-2"></div>
                                                                <div className="gcc-certificate-title col-md-12 text-center">
                                                                    <img src={require("../../images/certificate_img/win_cert_logo.png")} className="img-fluid pc_cert_logo" alt="logo" title="participate_certificate" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="pm-certificate-body p-4 mb-3">
                                                            <div className="pm-certificate-block row">
                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="pm-certificate-name margin-0 col-md-12 text-center mt-3">
                                                                            <img src={require("../../images/certificate_img/pc-cert-font.png")} className="img-fluid pc_cert_font" alt="logo" title="winner_certificate" />
                                                                            <span className="padding-0 mb-3 block cursive text-bold"> Is proud to awarded this certificate to</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-1"></div>
                                                                        <div className="col-md-2 gcc-course-title" ref={studentGenderRef}>Mr./Ms. </div>
                                                                        <div className="pm-course-title underline-gold col-md-8 text-center mt-2">
                                                                            <span className="pm-credits-text block arima"><span className="" ref={studentNameRef}></span></span>
                                                                        </div>
                                                                        <div className="col-md-1"></div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-2"></div>
                                                                        <div className="pm-course-title col-md-8 text-center mt-2">
                                                                            <span className="block cursive">from</span>
                                                                        </div>
                                                                        <div className="col-md-2"></div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row mt-2">
                                                                        <div className="col-md-2"></div>
                                                                        <div className="pm-course-title underline_gcc col-md-8 text-center">
                                                                            <span className="pm-credits-text block bold arima" ref={studentCollegeRef}></span>
                                                                        </div>
                                                                        <div className="col-md-2"></div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-2"></div>
                                                                        <div className="pm-course-title col-md-8 text-center">
                                                                            <span className=" block cursive">For his/her innovative solution</span>
                                                                        </div>
                                                                        <div className="col-md-2"></div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row mt-4">
                                                                        <div className="col-md-2"></div>
                                                                        <div className="pm-course-title underline_gcc col-md-8 text-center">
                                                                            <span className="pm-credits-text block sans"></span>
                                                                        </div>
                                                                        <div className="col-md-2"></div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row">
                                                                        <div className="pm-course-title col-md-12 text-center">
                                                                            <span className=" block cursive">Being adjudged as the of the industry use case</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-12">
                                                                    <div className="row mt-2">
                                                                        <div className="col-md-1"></div>
                                                                        <div className="pm-course-title underline_gcc col-md-10 text-center mt-3">
                                                                            <span className="pm-credits-text block bold arima" ref={challengeNameRef}></span>
                                                                        </div>
                                                                        <div className="col-md-1"></div>
                                                                    </div>

                                                                    <div className="row mt-2">
                                                                        <div className="col-md-1 mt-1 gcc-earned-text ms-2">By</div>
                                                                        <div className="pm-course-title underline_gcc col-md-10 text-center">
                                                                            <span className=" block arima" ref={companyNameRef}></span>
                                                                        </div>
                                                                        <div className="col-md-1 gcc-course-title"></div>
                                                                    </div>

                                                                    <div className="row mt-4">
                                                                        <div className="col-md-1"></div>
                                                                        <div className="pm-course-title col-md-10 text-center">
                                                                            <span className="cursive block">Heartiest Congratulation! <br />Keep Innovationg!!</span>
                                                                        </div>
                                                                        <div className="col-md-1"></div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div className="col-md-12 mt-2">
                                                                <div className="row arima">
                                                                    <div className="col-md-4 mt-3 pm-certified text-center">
                                                                        <span><img src={require("../../images/empty_logo.png")} width={60} height={60} className="img-fluid mt-4" alt="logo" title="Profile" ref={companyLogoRef} /></span>
                                                                        <span className="block text-secondary mt-2 foot_text">Industry partner</span>
                                                                    </div>
                                                                    <div className="col-md-4 pm-certified text-center mt-3">
                                                                        <span><img src={require("../../images/sign.png")} width={50} height={50} className="img-fluid" alt="logo" title="Profile" /></span>
                                                                        <span className="bold block">Anagaha Komawar</span>
                                                                        <span className="text-secondary block foot_text">Co-founder <br />Grok Learning Pvt Ltd.</span>
                                                                        <span className="text-secondary block"></span>
                                                                    </div>
                                                                    <div className="col-md-4 pm-certified text-center mt-5">
                                                                        <span><img src={require("../../images/grok pvt ltd logo.png")} className="img-fluid cert-logo" alt="logo" title="Profile" /></span>
                                                                        <span className="block text-secondary foot_text me-5">Date of Issue: </span>
                                                                        <span className="block text-secondary foot_text me-3">www.grovator.com</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row text-center mt-4'>
                                                                <h5 className='certified-no arima mx-2 text-bold'>Certificate No : <b ref={certificateIdRef}></b> </h5>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                            </div>
                        </Modal>
                    </div>

                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default WinnerAnnouncement; 